import {
    getQuestionnaireStatusMeta,
    QUALITY_CONTROL_FORM_STATUS,
} from "../ManualEvaluationDialog/manualEvaluationQuestionnaires";

export const QUALITY_CONTROL_STATISTICS_FIELD_LABELS: Record<string, string> = {
    qualityControlStatus: 'Статус оцінки',
    qualityControlId: 'ID / Анкета',
    qualityControlName: 'Анкета',
    qualityControlFullName: 'ID / Анкета',
    start: 'Початок',
    end: 'Завершення',
    fullName: 'Оператор',
    ani: 'Клiент',
    aNumber: 'Транк',
    ownerUserName: 'Власник дзвінка',
    direction: 'Тип Активності',
    campaignFullName: 'ID / Назва Кампанii',
    branchId: 'ID / Branch',
    queueFullName: 'ID / Назва Черги',
    status: 'Статус',
    callType: 'Активність',
    ownerType: 'Тип власника',
    callResetName: 'Завершив',
    forcedClosing: 'Причина завершення',
    duration: 'Тривалість розмови',
    fullCallDuration: 'Тривалість дзвінка',
    reactionClient: 'Реакція Клієнта',
    reactionOperator: 'Реакція Оператора',
    contactName: 'Контакт',
    score: 'Оцінка',
    evaluationScore: 'Оцінка',
    evaluationUserName: 'Оцінювач',
    createdByUserFullName: 'Оцінювач',
    CreatedByUserFullName: 'Оцінювач',
    evaluationDate: 'Дата оцінки',
    isManual: 'Тип оцінки',
    controlEnd: 'Завершення оцінки',
};

export const QUALITY_CONTROL_STATISTICS_FILTER_KEYS: Record<string, string> = {
    qualityControlStatus: 'QualityControlStatus',
    qualityControlId: 'QualityControlId',
    qualityControlName: 'QualityControlId',
    qualityControlFullName: 'QualityControlId',
    start: 'Start',
    end: 'End',
    fullName: 'UserName',
    ani: 'ANI',
    aNumber: 'ANumber',
    ownerUserName: 'OwnerUserName',
    direction: 'Direction',
    campaignFullName: 'CampaignId',
    branchId: 'BranchId',
    queueFullName: 'QueueId',
    status: 'Status',
    callType: 'CallType',
    ownerType: 'OwnerType',
    callResetName: 'CallReset',
    forcedClosing: 'ForcedClosing',
    duration: 'Duration',
    fullCallDuration: 'FullCallDuration',
    score: 'Score',
    evaluationScore: 'EvaluationScore',
    evaluationUserName: 'EvaluationUserName',
    createdByUserFullName: 'CreatedByUserFullName',
    evaluationDate: 'EvaluationDate',
    isManual: 'IsManual',
    controlEnd: 'ControlEnd',
};

export const QUALITY_CONTROL_STATISTICS_SORT_KEYS: Record<string, string> = {
    'item.qualityControlStatus': 'QualityControlStatus',
    'item.qualityControlId': 'QualityControlId',
    'item.qualityControlName': 'QualityControlId',
    'item.qualityControlFullName': 'QualityControlId',
    'item.start': 'Start',
    'item.end': 'End',
    'item.fullName': 'UserName',
    'item.ani': 'Ani',
    'item.aNumber': 'ANumber',
    'item.ownerUserName': 'OwnerUserName',
    'item.direction': 'Direction',
    'item.campaignId': 'CampaignId',
    'item.branchId': 'BranchId',
    'item.queueId': 'QueueId',
    'item.status': 'Status',
    'item.callType': 'CallType',
    'item.forcedClosing': 'ForcedClosing',
    'item.duration': 'Duration',
    'item.fullCallDuration': 'FullCallDuration',
    'item.evaluationScore': 'EvaluationScore',
    'item.score': 'Score',
    'item.isManual': 'IsManual',
    'item.evaluationUserName': 'EvaluationUserName',
    'item.createdByUserFullName': 'CreatedByUserFullName',
    'item.evaluationDate': 'EvaluationDate',
    'item.controlEnd': 'ControlEnd',
    QualityControlStatus: 'QualityControlStatus',
    QualityControlId: 'QualityControlId',
    Start: 'Start',
    End: 'End',
    Status: 'Status',
    Username: 'UserName',
    UserName: 'UserName',
    CampaignId: 'CampaignId',
    BranchId: 'BranchId',
    QueueId: 'QueueId',
    Id: 'Id',
};

export const getQualityControlStatisticsFieldLabel = (name: string) =>
    QUALITY_CONTROL_STATISTICS_FIELD_LABELS[name] || name;

export const isRemovedQualityControlStatisticsField = (name?: string | null) =>
    String(name || '').replace(/^item\./, '') === 'controlStart';

export const toQualityControlApiSortField = (sortField: string) => {
    if (QUALITY_CONTROL_STATISTICS_SORT_KEYS[sortField]) {
        return QUALITY_CONTROL_STATISTICS_SORT_KEYS[sortField];
    }

    const normalized = sortField.replace(/^item\./, '');
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const QUALITY_CONTROL_STATUS_OPTIONS = [
    QUALITY_CONTROL_FORM_STATUS.NOT_STARTED,
    QUALITY_CONTROL_FORM_STATUS.EVALUATING,
    QUALITY_CONTROL_FORM_STATUS.COMPLETED,
].map((dictionaryId) => {
    const statusMeta = getQuestionnaireStatusMeta(dictionaryId, {isRated: dictionaryId === QUALITY_CONTROL_FORM_STATUS.COMPLETED});

    return {
        dictionaryId,
        name: statusMeta.label,
        badgeClassName: statusMeta.badgeClassName,
    };
});

export const expandQualityControlStatusFilterValues = (values: unknown[]): number[] => {
    const expanded = new Set<number>();

    values.forEach((value) => {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) {
            return;
        }

        expanded.add(parsed);
        if (parsed === QUALITY_CONTROL_FORM_STATUS.NOT_STARTED) {
            expanded.add(QUALITY_CONTROL_FORM_STATUS.IN_PROGRESS);
        }
    });

    return Array.from(expanded);
};

export const QUALITY_CONTROL_EVALUATION_TYPE_LABELS = {
    manual: 'Ручна оцінка',
    ai: 'ШІ оцінка',
} as const;

export const getQualityControlEvaluationTypeLabel = (isManual: unknown) => {
    if (isManual === true || isManual === 'true' || isManual === 1 || isManual === '1') {
        return QUALITY_CONTROL_EVALUATION_TYPE_LABELS.manual;
    }
    if (isManual === false || isManual === 'false' || isManual === 0 || isManual === '0') {
        return QUALITY_CONTROL_EVALUATION_TYPE_LABELS.ai;
    }
    return '- - -';
};

export const QUALITY_CONTROL_EVALUATION_TYPE_OPTIONS = [
    {value: 'true', name: QUALITY_CONTROL_EVALUATION_TYPE_LABELS.manual},
    {value: 'false', name: QUALITY_CONTROL_EVALUATION_TYPE_LABELS.ai},
];

export const getCallIdFromQualityControlRow = (row: any) =>
    row?.item?.id
    ?? row?.item?.callId
    ?? row?.item?.callDetailId
    ?? row?.id
    ?? null;
